"use client";

import RouteHighlights from "@/components/pages/flight/RouteHighlights";

export default function CountryHighlightsClient({
  cheapestRoutes,
  title,
  countryInformationPassedData,
}) {
  return (
    <RouteHighlights
      cheapestRoutes={cheapestRoutes}
      title={title}
      countryInformationPassedData={countryInformationPassedData}
      airlineName={countryInformationPassedData?.AirlineName}
      airlineSlug={
        countryInformationPassedData?.AirlineSlug ?? cheapestRoutes?.AirlineSlug
      }
    />
  );
}
